import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type {
  DryerInputs,
  DryerParams,
  DryerState,
  DryerSteadyOutputs,
  DryerStepOutputs,
} from './types';

/** Konvektiv quritgich (continuous / batch) — UnitModel. */
export const convectiveDryer: UnitModel<
  DryerParams,
  DryerInputs,
  DryerState,
  DryerStepOutputs,
  DryerSteadyOutputs
> = {
  id: 'convective-dryer',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export * from './psychrometrics';
export * from './kinetics';
export {
  solveSteady,
  solveContinuous,
  solveBatchDesign,
  batchKinetics,
  heaterStates,
} from './steady';
export { initState, stepDynamic } from './dynamic';
